<script>
    import { page } from "$app/stores";
    import { mobileMenuOpened } from "/src/store.js";
    import { t, locales, locale } from "$lib/translations";
    import Logo from "$lib/images/logo.svg";
    import Wallet from "$lib/images/wallet.svg";
    import Ukraine from "$lib/images/ua.webp";
    import English from "$lib/images/en.webp";
    import German from "$lib/images/de.webp";
    import Georgian from "$lib/images/ge.webp";
    import Poland from "$lib/images/pl.webp";
    import France from "$lib/images/fr.webp";
    import { goto } from "$app/navigation";
    export let navLinks;

    let currentPath;
    let donateInGame = false;
    let userAgreementInGame = false;
    let menuState = false;
    let langList = false;

    $: {
        currentPath = $page.url.pathname;
        donateInGame =
            currentPath.includes("/donate-in-game") ||
            currentPath.includes("/game-purchase") ||
            currentPath.includes("/user-agreement-in-game");
        userAgreementInGame = currentPath.includes("/user-agreement-in-game");
    }

    $: ({ route } = $page.data);

    export function toggleMenu() {
        menuState = !menuState;
        mobileMenuOpened.set(menuState);
    }

    const openLangList = () => {
        langList = !langList;
    };

    function handleLanguageChange(newLocale) {
        const restrictedPaths = ["/shop", "/cart"];
        const isRestricted = restrictedPaths.some(path => currentPath.includes(path));

        if (isRestricted && newLocale !== "ua") {
            goto(`/${newLocale}`);
        } else {
            goto(`/${newLocale}${route}`);
        }

        langList = false;
    }

    function getFlagImage(locale) {
        return locale === "ua"
            ? Ukraine
            : locale === "en"
              ? English
              : locale === "pl"
                ? Poland
                : locale === "fr"
                  ? France
                  : locale === "de"
                    ? German
                    : Georgian;
    }

    function getLanguageName(locale) {
        return locale === "ua"
            ? "Ukrainian"
            : locale === "en"
              ? "English"
              : locale === "pl"
                ? "Polish"
                : locale === "fr"
                  ? "French"
                  : locale === "de"
                    ? "German"
                    : "Georgian";
    }
</script>

<header>
    {#if !donateInGame}
        <nav>
            <div class="left-side">
                <a href="/{$locale}"
                    ><div class="logo">
                        <img src={Logo} alt="Logo" />
                    </div></a
                >
                <div class="nav-links">
                    <ul>
                        {#if navLinks && navLinks.length > 0}
                            {#each $locale === "ua" ? navLinks : navLinks.slice(0, 4) as link}
                                <li>
                                    <a
                                        href={link.endpoint}
                                        target={link.blank ? "_blank" : null}
                                        class:active={currentPath === link.endpoint}>{link.name}</a
                                    >
                                </li>
                            {/each}
                        {/if}
                    </ul>
                </div>
            </div>
            <div class="right-side">
                <div class="language">
                    <div class="current-lang">
                        <div class="lang" on:click={openLangList} aria-hidden="true">
                            <img
                                src={$locale === "ua"
                                    ? Ukraine
                                    : $locale === "en"
                                      ? English
                                      : $locale === "pl"
                                        ? Poland
                                        : $locale === "fr"
                                          ? France
                                          : $locale === "de"
                                            ? German
                                            : Georgian}
                                alt={$locale === "ua"
                                    ? "Ukrainian"
                                    : $locale === "en"
                                      ? "English"
                                      : $locale === "pl"
                                        ? "Polish"
                                        : $locale === "fr"
                                          ? "French"
                                          : $locale === "de"
                                            ? "German"
                                            : "Georgian"}
                            />
                        </div>
                    </div>

                    <div class="lang-list" class:opened={langList}>
                        {#each $locales as lc}
                            {#if lc !== $locale}
                                <div class="lang" on:click={() => handleLanguageChange(lc)} aria-hidden="true">
                                    <img src={getFlagImage(lc)} alt={getLanguageName(lc)} />
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>

                <div class="donate">
                    <a href="/{$locale}/donate/"
                        ><button class="btn btn-primary">
                            <div class="icon">
                                <img src={Wallet} alt="Wallet" />
                            </div>
                            <div class="text">
                                {$t("header.donate")}
                            </div>
                        </button></a
                    >
                </div>
                <button class="btn open-button" class:opened={$mobileMenuOpened} on:click={toggleMenu}>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                </button>
            </div>
        </nav>
    {:else if donateInGame}
        <nav>
            <div class="left-side">
                {#if !userAgreementInGame}
                    <div class="logo">
                        <img src={Logo} alt="Logo" />
                    </div>
                {:else if userAgreementInGame}
                    <a href="/{$locale}/donate-in-game">
                        <div class="logo">
                            <img src={Logo} alt="Logo" />
                        </div>
                    </a>
                {/if}
                <div class="nav-links"></div>
            </div>
            <div class="right-side"></div>
        </nav>
    {/if}
</header>

<style lang="scss">
    @import "/src/lib/scss/main";

    @mixin after-links {
        content: "";
        position: absolute;
        background-color: #fed500;
        width: 0;
        height: 2px;
        top: 20px;
        left: 0;
        border-radius: 30px;
    }

    header {
        padding: 30px 100px 0;
    }

    nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        .left-side {
            display: flex;
            align-items: center;
            gap: 105px;
        }
    }

    .logo {
        width: 40px;
        height: 40px;
        cursor: pointer;
    }

    .nav-links {
        ul {
            display: flex;
            gap: 70px;
            list-style-type: none;

            li {
                & > a {
                    position: relative;
                    transition: opacity $default-transition-time;
                    color: #fffbef;
                    opacity: 0.6;
                    text-decoration: none;
                    font-weight: 300;

                    &:after {
                        @include after-links;
                        transition: width $default-transition-time;
                    }

                    &:hover {
                        opacity: 1;

                        &:after {
                            width: 75%;
                        }
                    }

                    &.active {
                        opacity: 1;

                        &:after {
                            width: 75%;
                        }
                    }
                }
            }
        }
    }

    .open-button {
        display: none;
        width: 30px;
        gap: 7px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 100;

        .line {
            width: 100%;
            height: 2px;
            background-color: white;
            transition:
                opacity 0.5s,
                transform 0.5s;
        }

        &.opened {
            gap: 0;

            & > .line {
                position: absolute;
            }
            & > .line:nth-child(1) {
                transform: rotate(45deg);
            }
            & > .line:nth-child(2) {
                transform: rotate(-45deg);
            }
            & > .line:nth-child(3) {
                opacity: 0;
            }
        }
    }

    .donate {
        height: 55px;
        width: 220px;

        & > a {
            text-decoration: none;
        }
    }

    .right-side {
        display: flex;
        align-items: center;
        gap: 60px;
    }

    .language {
        .lang {
            display: flex;
            width: 30px;
            cursor: pointer;

            & > img {
                border-radius: 3px;
                width: 30px;
                height: 20px;
            }
        }

        & > .lang-list {
            display: flex;
            flex-direction: column;
            gap: 5px;
            position: absolute;
            top: 42px;
            opacity: 0;
            pointer-events: none;

            &.opened {
                opacity: 1;
                pointer-events: auto;
            }
        }
    }

    @media screen and (max-width: 1300px) {
        header {
            padding: 30px 30px 0;
        }
        .left-side {
            gap: 50px !important;
        }
    }

    @media screen and (max-width: 1100px) {
        .language {
            margin-right: 45px;
        }

        .donate,
        .nav-links {
            display: none;
        }
        .open-button {
            display: flex !important;
        }
    }
</style>
